module.exports = __webpack_public_path__ + "static/scale-model-of-viva-tours-in-plano-texas-d4ffc9538330f479e6fd88b4f8259d8e.png";